import SliceManager from 'components/shared/SliceManager'
import ComparatorsDisclaimer from 'src/components/pages/comparators/ComparatorsDisclaimer'
import ComparatorsIntro from 'src/components/pages/comparators/ComparatorsIntro'
import ComparatorsTable from 'src/components/pages/comparators/ComparatorsTable'
import RelatedComparators from 'src/components/slices/RelatedComparators'
import {
  fetchComparators,
  buildStaticPaths,
  getDataDependencies,
} from 'src/services/api'
import fetchAllSlugs from 'src/lib/Strapi/fetchAllSlugs'

import PreviewBanner from 'components/shared/PreviewBanner'

import css from './styles.module.scss'

const SingleComparator = ({
  comparators,
  pageData: { firstCMS, secondCMS, title, description, label, slices },
  preview,
}) => {
  return (
    <div className={css.container}>
      {preview && <PreviewBanner />}
      <div className={css.mainSection}>
        <ComparatorsIntro label={label} title={title} subTitle={description} />
        <ComparatorsTable firstCMS={firstCMS} secondCMS={secondCMS} />
        <ComparatorsDisclaimer />
      </div>
      {slices && <SliceManager slices={slices} />}
      <RelatedComparators comparators={comparators} />
    </div>
  )
}

export async function getStaticPaths() {
  const data = await fetchAllSlugs('comparators')
  return buildStaticPaths(data, 'headless-cms/comparison')
}

export async function getStaticProps({ params, preview = null }) {
  const comparator = await fetchComparators(params.slug, preview)
  const [pageData] = comparator

  const { firstCMS, secondCMS } = pageData

  const comparators = await fetchComparators(
    null,
    `filters[$or][0][slug][$contains]=${firstCMS.slug}&filters[$or][1][slug][$contains]=${secondCMS.slug}`,
    preview
  )
  const extendedData = await getDataDependencies(pageData)

  if (comparator?.length === 0 || !comparator) {
    return {
      props: {},
      notFound: true,
    }
  }

  return {
    props: {
      pageData: extendedData,
      comparators,
      preview,
    },
  }
}

export default SingleComparator
